var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkEmailRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "1 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M628.769-94.617 472.616-250.768l42.153-42.153 114 114 226.769-226.769 42.153 42.152L628.769-94.616ZM480-520l313.846-200H166.154L480-520Zm0 62.306L160-662.309v410q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462H371l59.999 59.999h-258.69q-30.308 0-51.308-21t-21-51.308v-455.382q0-30.308 21-51.308t51.308-21h615.382q30.308 0 51.308 21t21 51.308v185.539L800-462.154v-200.155L480-457.694Zm0 6.539ZM480-520Zm0 62.306Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkEmailRead);
export default __webpack_public_path__ + "static/media/mark_email_read.8c742efdf3139bfe7ba23aee9d3ec91a.svg";
export { ForwardRef as ReactComponent };